import { render, staticRenderFns } from "./AuthSetPassword.vue?vue&type=template&id=efe291da&scoped=true"
import script from "./AuthSetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthSetPassword.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AuthSetPassword.vue?vue&type=style&index=0&id=efe291da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe291da",
  null
  
)

export default component.exports